import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { BannerComponent } from '@app/components';
import { T4Notification } from '@app/modules/payroll/services/t4-notifications.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-employee-t4-notifications',
    standalone: true,
    imports: [BannerComponent, TranslateModule, NgTemplateOutlet],
    template: `
        @if (hasDefinedContributionOrProfitSharingNotification()) {
            <ng-container
                [ngTemplateOutlet]="banner"
                [ngTemplateOutletContext]="{ translateKey: 'ourRecordsShowThatEmployeeHadARPPWithADCAndOrPSA' }"
            />
        }

        @if (hasDefinedBenefitsNotification()) {
            <ng-container
                [ngTemplateOutlet]="banner"
                [ngTemplateOutletContext]="{ translateKey: 'ourRecordsShowThatEmployeeHadARPPWithADB' }"
            />
        }

        <ng-template #banner let-translateKey="translateKey">
            <ui-banner variant="danger">
                <div translate="payroll.taxForms.{{ translateKey }}" [translateParams]="{ name: name(), year: year() }">
                    <div [innerHTML]="'payroll.taxForms.forMoreInformationPleaseVisit' | translate"></div>
                </div>
            </ui-banner>
        </ng-template>
    `,
    styles: [
        `
            :host {
                display: contents;
            }
        `,
    ],
})
export class EmployeeT4NotificationsComponent {
    name = input.required<string>();
    year = input.required<number>();
    employeeNotifications = input<T4Notification>();

    hasDefinedBenefitsNotification = computed(() => {
        const employeeNotifications = this.employeeNotifications();
        return (
            employeeNotifications &&
            employeeNotifications.boxes.includes('50') &&
            employeeNotifications.boxes.includes('52')
        );
    });

    hasDefinedContributionOrProfitSharingNotification = computed(() => {
        const employeeNotifications = this.employeeNotifications();
        return (
            employeeNotifications &&
            employeeNotifications.boxes.includes('50') &&
            !employeeNotifications.boxes.includes('52')
        );
    });
}
